export const colorOpacityParser = (opacity: number) => {
  const parsedOpacity = Math.round(opacity * 2.55)
  return parsedOpacity.toString(16)
}
